import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import {
  isLoggedUserSelector,
  targetUserSelector,
} from '../../../redux/context/selectors';
import { actions } from '../../../redux/profiles/edit-provider';
import { selectUsStates } from '../../../redux/data/selectors';
import styles from '../index.styl';

const mapStateToProps = state => ({
  profile: targetUserSelector(state),
  rawGenderList: state.data.processedConsts.genderTypes,
  languageList: state.data.processedConsts.languageTypes,
  statesList: selectUsStates(state),
  canEdit: isLoggedUserSelector(state),
});

const mapDispatchToProps = {
  saveProvider: actions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProviderInfo/enhance.js